import { ChakraComponent, Link } from '@chakra-ui/react';
import { LinkProps } from 'react-router-dom';
import { reactEvents } from 'src/bridge/reactEvents';

export interface AngularNavLinkProps extends LinkProps {
  navobj?: any;
  variant?: string;
}

type LinkComponent = ChakraComponent<'a', AngularNavLinkProps>;

export const AngularNavLink = ((props: AngularNavLinkProps) => {
  const isCurrent = window.location.hash.includes(props.to.toString());

  function clicked(e: any) {
    e.preventDefault();
    if (props.onClick !== undefined) {
      e.stopPropagation();
      props.onClick(e);
    }
    reactEvents.routingChanged.dispatch({
      to: props.to.toString(),
      navObj: props.navobj,
      newTab: e.button === 1,
    });
  }

  return (
    <Link
      variant={props.variant ?? 'underline'}
      {...props}
      {...(isCurrent ? { 'aria-current': 'page' } : null)}
      onAuxClick={clicked}
      onClick={clicked}
    >
      {props.children}
    </Link>
  );
}) as LinkComponent;
